<template>
  <Card class="form-stepper-card sm:mt-16 box-shadow-none sm:box-shadow-sm sm:p-24">
    <h1 class="text-h2 centered mt-24 mb-16">Other requirements</h1>
    <p class="text-body centered mb-24">What other requirements and responsibilities should sitters be aware of?</p>

    <form>
      <h2 class="text-small font-medium">Requirements</h2>
      <RequirementsSection :requirements.sync="requirements" :languages.sync="languages" />
      <h2 class="text-small font-medium">Responsibilities</h2>
      <ResponsibilitiesSection :responsibilities.sync="responsibilities" />
      <div class="flex flex-row-reverse">
        <RouteStepperNextButton :stepData="reviewSection" :draftData="draftData" />
      </div>
    </form>
  </Card>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import RequirementsSection from './RequirementsSection.vue';
import ResponsibilitiesSection from './ResponsibilitiesSection.vue';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import formatJobDetails from './RequirementsFormatter';
import { ReviewSection } from '@/components/route_stepper/types';
import { Requirements, Responsibilities, Languages } from '@/store/modules/job/types';
import { JobPostDraft } from '../types';
import RouteStepperNextButton from '@/components/route_stepper/RouteStepperNextButton.vue';

interface JobPostRequirementsData {
  requirements: Requirements[];
  responsibilities: Responsibilities[];
  languages: Languages[];
}

export default {
  name: 'JobPostRequirements',
  components: {
    Card,
    RequirementsSection,
    ResponsibilitiesSection,
    RouteStepperNextButton,
  },
  data(): JobPostRequirementsData {
    return {
      requirements: [],
      responsibilities: [],
      languages: [],
    };
  },
  computed: {
    reviewSection(): ReviewSection | any {
      const valueLabels = formatJobDetails({
        requirements: this.requirements,
        responsibilities: this.responsibilities,
        languages: this.languages,
      });

      if (valueLabels.length === 0) return {};

      return {
        title: 'Requirements & Responsibilities',
        component: CheckmarkList,
        props: {
          tips: valueLabels,
        },
        editPath: this.$route.path,
      };
    },
    draftData(): JobPostDraft {
      return {
        requirements: this.requirements,
        responsibilities: this.responsibilities,
        languages: this.languages,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.form-stepper-card {
  @media (max-width: 480px) {
    background-color: #fbfbfb !important;
  }
}
</style>
